import { observer } from "mobx-react"

const Header = observer(() => {
    const handleNavigateJoin = () => {
        const element = document.getElementById("contractAdress");
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
    return (<>
        <header className=" text-white text-center mt-5">
            <img src="assets/img/snowball2.png" className="header-img img-fluid" />
            <img src="assets/img/front.png" className="header-img-coin img-fluid" />
            <h1 className="display-1 weird-title">
                <span>
                    <img src="assets/img/snowball4.png" className="span-img" />
                </span>{" "}
                SnowballBoss{" "}
                <span>
                    <img src="assets/img/snowball4.png" className="span-img" />
                </span>
            </h1>
            <p className="lead">The Chaos Coin of Mischief, Community, and Fun!</p>
            <button className="btn btn-warning btn-lg bounce" onClick={handleNavigateJoin}>Join the Chaos</button>
            <section className="snowball-intro">
                <div className="snowball-container">
                    
                    
                    <article>
                        <h1 className="fifth">Welcome to SnowballBoss</h1>
                        <p>The Chaos Coin of Mischief, Community, and Fun!</p>
                    </article>

                
                    <p className="intro-text">
                        <strong>SnowballBoss</strong> is a next-generation memecoin built on the{" "}
                        <strong>Binance Smart Chain (BSC)</strong> with the goal of combining
                        entertainment, finance, and a strong community. Inspired by the fearless
                        and mischievous Snowball, the rabbit from{" "}
                        <em>The Secret Life of Pets</em>, SnowballBoss seeks to bring
                        lightheartedness to the crypto space while introducing innovative
                        features that make it both fun and functional.
                    </p>
                    <p className="intro-text">
                        
                        The ecosystem thrives on <strong>community engagement</strong> and{" "}
                        <strong>creative marketing initiatives</strong>, embodying the playful
                        energy of Snowball while making a real impact. With SnowballBoss, crypto
                        becomes more than an investment—it’s a celebration of fun, community,
                        and purpose!
                    </p>
                </div>
                
            </section>
        </header>
    </>)
});

export default Header;